<template>
  <div @click="showSubscriptionPage" class="flex">
    <slot name="body">
      <button
          class="flex bg-brand-lime rounded-full w-full h-14 font-medium text-xl text-brand-black">
        <div class="flex m-auto space-x-2.5">
          <div class="my-auto pt-0.5">
            {{ label }}
          </div>
        </div>
      </button>
    </slot>
  </div>
</template>
<script lang="ts">

import {defineComponent} from "vue";
import {billingService} from "@/services/billing/billingService";

export default defineComponent({
  name: 'InAppSubscription',
  props: {
    label: {
      type: String,
      default: 'Upgrade to Pineapple Premium'
    }
  },
  setup() {

    const showSubscriptionPage = async () => {
      await billingService.presentPaywall('premium')
    }

    return {
      showSubscriptionPage
    }

  }
});

</script>
